export default "__VITE_ASSET__BvCucuLX__"